import { ObjectUtils } from "../primitive-utils";
import { isString } from "../type-guards";
export const AllowPolicy = {
    LogixWeb: {
        Transport: {
            Order: {
                Lock: "Allow:LogixWeb:Transport:Order:Lock",
            },
        },
    },
    Account: {
        User: {
            Write: "Allow:Account:User:Write",
        },
        Role: {},
    },
};
export const DenyPolicy = {
    LogixWeb: {
        Access: "Deny:LogixWeb:Access",
        Transport: {
            Access: "Deny:LogixWeb:Transport:Access",
            Order: {
                Access: "Deny:LogixWeb:Transport:Order:Access",
            },
            OrderScheduler: {
                Access: "Deny:LogixWeb:Transport:OrderScheduler:Access",
            },
            DocumentOutput: {
                Access: "Deny:LogixWeb:Transport:DocumentOutput:Access",
            },
            RegularOrder: {
                Access: "Deny:LogixWeb:Transport:RegularOrder:Access",
                Write: "Deny:LogixWeb:Transport:RegularOrder:Write",
            },
            TransportContract: {
                Access: "Deny:LogixWeb:Transport:TransportContract:Access",
                Write: "Deny:LogixWeb:Transport:TransportContract:Write",
            },
        },
        Labor: {
            Access: "Deny:LogixWeb:Labor:Access",
            AttendanceSchedule: {
                Access: "Deny:LogixWeb:Labor:AttendanceSchedule:Access",
                Write: "Deny:LogixWeb:Labor:AttendanceSchedule:Write",
            },
            Attendance: {
                Access: "Deny:LogixWeb:Labor:Attendance:Access",
                Write: "Deny:LogixWeb:Labor:Attendance:Write",
            },
            AttendanceDashboard: {
                Access: "Deny:LogixWeb:Labor:AttendanceDashboard:Access",
            },
        },
        Fleet: {
            Access: "Deny:LogixWeb:Fleet:Access",
            FleetLedger: {
                Access: "Deny:LogixWeb:Fleet:FleetLedger:Access",
            },
            FleetCalendar: {
                Access: "Deny:LogixWeb:Fleet:FleetCalendar:Access",
            },
            FleetFileBox: {
                Access: "Deny:LogixWeb:Fleet:FleetFileBox:Access",
            },
            TruckMaintenancePlanList: {
                Access: "Deny:LogixWeb:Fleet:TruckMaintenancePlan:Access",
            },
            TruckPrimeCost: {
                Access: "Deny:LogixWeb:Fleet:TruckPrimeCost:Access",
            },
            FuelCost: {
                Access: "Deny:LogixWeb:Fleet:FuelCost:Access",
            },
            TollRoadCost: {
                Access: "Deny:LogixWeb:Fleet:TollRoadCost:Access",
            },
            Maintenance: {
                Access: "Deny:LogixWeb:Fleet:Maintenance:Access",
            },
        },
        CostControl: {
            Access: "Deny:LogixWeb:CostControl:Access",
        },
        Billing: {
            Access: "Deny:LogixWeb:Billing:Access",
        },
        Payment: {
            Access: "Deny:LogixWeb:Payment:Access",
        },
        Dashboard: {
            Access: "Deny:LogixWeb:Dashboard:Access",
            Read: "Deny:LogixWeb:Dashboard:Read",
            DashboardMonthly: {
                Access: "Deny:LogixWeb:Dashboard:DashboardMonthly:Access",
            },
            DashboardDaily: {
                Access: "Deny:LogixWeb:Dashboard:DashboardDaily:Access",
            },
            DashboardQuickSight: {
                Access: "Deny:LogixWeb:Dashboard:DashboardQuickSight:Access",
            },
        },
        Master: {
            Access: "Deny:LogixWeb:Master:Access",
            All: {
                Write: "Deny:LogixWeb:Master:All:Write",
            },
            Company: {
                Access: "Deny:LogixWeb:Master:Company:Access",
                Write: "Deny:LogixWeb:Master:Company:Write",
            },
            Spot: {
                Access: "Deny:LogixWeb:Master:Spot:Access",
                Write: "Deny:LogixWeb:Master:Spot:Write",
            },
            Load: {
                Access: "Deny:LogixWeb:Master:Load:Access",
                Write: "Deny:LogixWeb:Master:Load:Write",
            },
            Driver: {
                Access: "Deny:LogixWeb:Master:Driver:Access",
                Write: "Deny:LogixWeb:Master:Driver:Write",
            },
            Truck: {
                Access: "Deny:LogixWeb:Master:Truck:Access",
                Write: "Deny:LogixWeb:Master:Truck:Write",
            },
            TransportChargeTable: {
                Access: "Deny:LogixWeb:Master:TransportChargeTable:Access",
                Write: "Deny:LogixWeb:Master:TransportChargeTable:Write",
            },
            Meta: {
                Access: "Deny:LogixWeb:Master:Meta:Access",
                Write: "Deny:LogixWeb:Master:Meta:Write",
            },
        },
        Account: {
            Access: "Deny:LogixWeb:Account:Access",
        },
    },
    LogixTimeRecorder: {
        Access: "Deny:LogixTimeRecorder:Access",
    },
    LogixNative: {
        Access: "Deny:LogixNative:Access",
    },
};
export const PolicyLiteralList = (() => {
    const extractPolicy = (v) => {
        return ObjectUtils.keys(v)
            .map((key) => {
            const target = v[key];
            return !isString(target)
                ? extractPolicy(target)
                : target;
        })
            .flat();
    };
    return [...extractPolicy(AllowPolicy), ...extractPolicy(DenyPolicy)];
})();
//# sourceMappingURL=policy.js.map